<div
  *transloco="let t; read: 'documents.list-settings'"
  class="xi-modal__container document-list-settings__container"
>
  <h2 class="xi-modal__title">{{ t('title') }}</h2>

  <xi-horizontal-tab-bar
    [data]="tabs"
    [(activeTabId)]="activeTab"
    [tabSpacing]="25"
    color="CX"
    [hasTransparentBackground]="true"
  >
  </xi-horizontal-tab-bar>

  <xi-left-right-picker
    [class.hide]="activeTab !== 'columns'"
    [data]="columnPickerData"
    [dragAndDropEnabled]="true"
    [useLegacyFormControl]="false"
    [localization]="{
      available: t('column-picker.available'),
      selected: t('column-picker.selected'),
      addButton: t('column-picker.add'),
      removeButton: t('column-picker.remove'),
      addAll: t('column-picker.add-all'),
      removeAll: t('column-picker.remove-all'),
      searchPlaceholder: t('column-picker.search'),
      results: t('column-picker.results'),
    }"
    (onItemsChanged)="onColumnSelectionChanged($event.detail)"
  ></xi-left-right-picker>

  <div class="document-list-settings__scroll" [class.hide]="activeTab !== 'labels'">
    <table mat-table [dataSource]="fieldLabelsDs" class="xi-table__table">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          <div class="xi-table__table-header-content">
            <div class="xi-table__table-header-border"></div>

            <span>{{ t('field-name') }}</span>
          </div>
        </th>

        <td mat-cell *matCellDef="let element">
          <div [matTooltip]="element.fieldName">
            <ng-container *appMiddleEllipsize="element.fieldName"></ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>
          <div class="xi-table__table-header-content">
            <div class="xi-table__table-header-border"></div>

            <span>{{ t('display-label') }}</span>
          </div>
        </th>

        <td mat-cell *matCellDef="let element" class="display-label-wrapper">
          <xi-input-field
            [(ngModel)]="element.displayLabel"
            [placeholder]="t('enter-name-to-display')"
            (onChange)="onDisplayNameChange(element)"
          ></xi-input-field>
          @if (element.isCustomField) {
            <xi-checkbox
              [label]="t('use-metadata-display-name')"
              color="CX"
              [(ngModel)]="element.useFieldDisplayName"
              (onCheckedChange)="onUseFieldDisplayNameChange(element, $event.detail.isChecked)"
            ></xi-checkbox>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="fieldLabelsColumns; sticky: true"></tr>

      <tr mat-row *matRowDef="let row; columns: fieldLabelsColumns"></tr>
    </table>

    @if (!fieldLabelsDs?.data.length) {
      <div class="document-list-settings__empty-selection">
        {{ t('no-fields-selected') }}
      </div>
    }
  </div>

  <div [class.hide]="activeTab !== 'viewer'" class="document-list-settings__scroll">
    <xi-toggle-switch
      [leftText]="t('off')"
      [rightText]="t('on')"
      color="CX"
      [isToggled]="isClickOpenDocument"
      (onToggle)="isClickOpenDocument = $event.detail.isToggled"
      [label]="t('open-document-on-click')"
      class="document-list-settings__open-document-cb"
    ></xi-toggle-switch>

    <div class="document-list-settings__viewer-form-group">
      <div class="xi-form-group__side--left">
        <xi-toggle-switch
          [leftText]="t('off')"
          [rightText]="t('on')"
          color="CX"
          [isToggled]="showNlpData"
          (onToggle)="showNlpData = $event.detail.isToggled"
          [label]="t('nlp-data')"
        ></xi-toggle-switch>

        <p>{{ t('nlp-data-description') }}</p>
      </div>

      <div class="xi-form-group__side--right">
        @if (showNlpData) {
          <mat-list
            cdkDropList
            (cdkDropListDropped)="onNlpFieldsReordered($event)"
            class="xi-draggable-list"
          >
            @for (item of nlpFields; track item) {
              <mat-list-item
                cdkDrag
                cdkDragPreviewContainer="parent"
                class="xi-draggable-list-item"
              >
                <div cdkDragHandle>
                  <xi-icon icon="drag_handle"></xi-icon>
                </div>
                <xi-checkbox
                  color="CX"
                  [label]="item.title"
                  [(ngModel)]="item.display"
                ></xi-checkbox>
              </mat-list-item>
            }
          </mat-list>
        }
      </div>
    </div>

    <div
      class="document-list-settings__viewer-form-group document-list-settings__viewer-form-group--metadata"
    >
      <div class="xi-form-group__side--left">
        <xi-toggle-switch
          [leftText]="t('off')"
          [rightText]="t('on')"
          color="CX"
          [isToggled]="showMetadata"
          (onToggle)="showMetadata = $event.detail.isToggled"
          [label]="t('meta-data')"
        ></xi-toggle-switch>

        <p>{{ t('meta-data-description') }}</p>
      </div>

      <div class="xi-form-group__side--right"></div>

      @if (showMetadata) {
        <xi-left-right-picker
          [data]="metadataPickerData"
          [useLegacyFormControl]="false"
          [localization]="{
            available: t('column-picker.available'),
            selected: t('column-picker.selected'),
            addButton: t('column-picker.add'),
            removeButton: t('column-picker.remove'),
            addAll: t('column-picker.add-all'),
            removeAll: t('column-picker.remove-all'),
            searchPlaceholder: t('column-picker.search'),
            results: t('column-picker.results'),
          }"
          (onItemsChanged)="onMetadataSelectionChanged($event.detail)"
        ></xi-left-right-picker>
      }
    </div>
  </div>

  <div [class.hide]="activeTab !== 'card'" class="document-list-settings__scroll">
    <div class="document-list-settings__viewer-form-group">
      <div class="xi-form-group__side--left">
        <xi-toggle-switch
          [leftText]="t('off')"
          [rightText]="t('on')"
          color="CX"
          [isToggled]="showQuickActions"
          (onToggle)="showQuickActions = $event.detail.isToggled"
          [label]="t('quick-actions.title')"
        ></xi-toggle-switch>

        <p>{{ t('quick-actions.description') }}</p>
        <br />
        <p>{{ t('quick-actions.instructions') }}</p>
      </div>

      <div class="xi-form-group__side--right">
        @if (showQuickActions) {
          <span class="quick-action-top">
            <p class="quick-action-top__active">{{ activeQuickActionsLabel }}</p>
            <xi-default-button
              type="button"
              [text]="t('quick-actions.add-action')"
              fill="text"
              iconLeft="add_circle"
              [disabled]="isEditMode || configuredQuickActions?.length >= 15"
              (onClick)="onAddAction()"
            ></xi-default-button>
          </span>
          <mat-list
            cdkDropList
            (cdkDropListDropped)="onQuickActionsReordered($event)"
            class="xi-draggable-list"
          >
            @for (item of configuredQuickActions; track item; let i = $index) {
              <mat-list-item
                cdkDrag
                cdkDragPreviewContainer="parent"
                class="xi-draggable-list-item list-item-border"
              >
                <div class="block-display">
                  <span class="quick-action-item">
                    <div cdkDragHandle>
                      <xi-icon icon="drag_handle"></xi-icon>
                    </div>
                    <xi-checkbox
                      color="CX"
                      [disabled]="activeQuickActionsCount >= 6 && !item.enabled"
                      [matTooltip]="t('quick-actions.disabled-checkbox-tooltip')"
                      [matTooltipDisabled]="!(activeQuickActionsCount >= 6 && !item.enabled)"
                      [(ngModel)]="item.enabled"
                      (onCheckedChange)="onQuickActionCheckChange(i, item.enabled)"
                    ></xi-checkbox>
                    @if (item.isEditMode) {
                      <div [matMenuTriggerFor]="iconMenu">
                        <ng-container
                          *ngTemplateOutlet="
                            quickActionIcon;
                            context: { $implicit: !item.isEditable }
                          "
                        ></ng-container>
                      </div>
                    } @else {
                      <ng-container
                        *ngTemplateOutlet="
                          quickActionIcon;
                          context: { $implicit: !item.isEditable }
                        "
                      ></ng-container>
                    }

                    <ng-template #quickActionIcon let-isDisabled>
                      <xi-icon
                        class="quick-action-item__icon"
                        [class.disabled]="isDisabled"
                        [icon]="item.icon"
                        mat-button
                      ></xi-icon>
                    </ng-template>

                    <mat-menu #iconMenu>
                      <div class="quick-action__icon-list">
                        @for (icon of listOfIcons; track icon) {
                          <xi-icon-button
                            class="quick-action-item__icon icon-list-margin"
                            [class.is-selected]="icon === item.icon"
                            [class.disabled]="
                              icon | isIconDisabled: listOfConfiguredIcons : item.icon
                            "
                            [icon]="icon"
                            [disabled]="icon | isIconDisabled: listOfConfiguredIcons : item.icon"
                            (onClick)="onQuickActionIconSelect(i, icon)"
                          ></xi-icon-button>
                        }
                      </div>
                    </mat-menu>
                    @if (item.isEditMode) {
                      <input
                        class="quick-action-item__name_action"
                        [class.has-error]="quickActionNameError"
                        type="text"
                        maxlength="30"
                        [placeholder]="t('quick-actions.name-quick-action')"
                        [(ngModel)]="item.title"
                        (input)="onQuickActionValueChange($event.target.value, item.id, 'title')"
                      />
                    } @else {
                      <p class="quick-action-item__title">
                        {{ item.title }}
                      </p>
                    }
                    @if (item.isEditable) {
                      <xi-icon-button
                        icon="edit"
                        class="quick-action-item__edit"
                        [disabled]="item.isEditMode || isEditMode"
                        (onClick)="onQuickActionEdit(item)"
                      ></xi-icon-button>
                    }
                  </span>
                  @if (quickActionNameError && item.isEditMode) {
                    <p class="error-message name-error">
                      <xi-icon icon="warning_filled" iconSize="small" color="error"></xi-icon>
                      {{ quickActionNameError }}
                    </p>
                  }
                  @if (item.isEditMode) {
                    <div class="quick-action-tag">
                      <xi-input-field
                        type="text"
                        maxlength="30"
                        [label]="t('quick-actions.tag-to-add')"
                        [status]="quickActionTagError ? { state: 'error' } : undefined"
                        [(ngModel)]="item.tag"
                        (keyup)="onQuickActionValueChange($event.target.value, item.id, 'tag')"
                      ></xi-input-field>
                      @if (quickActionTagError) {
                        <p class="error-message">
                          <xi-icon icon="warning_filled" iconSize="small" color="error"></xi-icon>
                          {{ quickActionTagError }}
                        </p>
                      }
                    </div>
                    <div class="quick-actions-delete-save">
                      <xi-default-button
                        type="button"
                        tone="light"
                        color="error"
                        [text]="t('quick-actions.delete')"
                        (onClick)="onQuickActionDelete(item)"
                      ></xi-default-button>
                      <xi-default-button
                        type="button"
                        [text]="t('quick-actions.save')"
                        [disabled]="
                          quickActionNameError || quickActionTagError || !item.title || !item.tag
                        "
                        (onClick)="onQuickActionSave(item)"
                      ></xi-default-button>
                    </div>
                  }
                </div>
              </mat-list-item>
            }
          </mat-list>
        }
      </div>
    </div>
  </div>

  <div class="document-list-settings__action xi-modal__actions">
    <xi-default-button
      type="button"
      [text]="t('cancel')"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>

    @if (!formValidity.isValid) {
      <span class="document-list-settings--invalid"> {{ formValidity.errorMessage }}</span>
    }

    <xi-default-button
      [text]="t('apply')"
      [disabled]="!formValidity.isValid || isEditMode"
      (onClick)="save()"
    ></xi-default-button>
  </div>
</div>
